<template>
  <v-app>
    <v-main class="pa-4">
      <v-container fluid>
        <v-card class="mb-4">
          <v-toolbar class="primary white--text">
            <v-icon color="white" left>mdi-cash-multiple</v-icon>
            ASIGNACION DE COBRANZA POR SEDE V7
            <v-spacer></v-spacer>
            <v-btn small outlined dark @click="$router.back()">
              <v-icon left small>mdi-arrow-left</v-icon>
              Volver
            </v-btn>
          </v-toolbar>
        </v-card>

        <v-card class="pa-4 mb-4" elevation="2">
          <v-row dense align="center">
            <v-col cols="12" sm="6" md="3">
              <v-menu v-model="menuFechaInicio" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaInicioMes"
                    label="Fecha inicio mes"
                    prepend-icon="mdi-calendar-start"
                    readonly
                    outlined
                    dense
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fechaInicioMes" @input="menuFechaInicio = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-menu v-model="menuFechaConsulta" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaConsulta"
                    label="Fecha consulta"
                    prepend-icon="mdi-calendar-check"
                    readonly
                    outlined
                    dense
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fechaConsulta" @input="menuFechaConsulta = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-alert dense outlined color="primary" class="mb-0">
                <div class="caption font-weight-medium">
                  <v-icon small color="primary">mdi-office-building</v-icon>
                  Sede seleccionada
                </div>
                <div class="caption">{{ sedeSeleccionadaTexto }}</div>
              </v-alert>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-btn color="primary" block :loading="loading" :disabled="loading" @click="cargarAsignaciones">
                <v-icon left>mdi-calculator</v-icon>
                Calcular
              </v-btn>
            </v-col>
          </v-row>
          <v-alert v-if="msg" dense outlined :type="msgType" class="mt-3 mb-0">
            {{ msg }}
          </v-alert>
        </v-card>

        <v-card class="mb-4" elevation="2">
          <v-tabs v-model="tabCalculo" background-color="primary" dark>
            <v-tab href="#mes">
              <v-icon left>mdi-calendar-month</v-icon>
              Asignacion del mes
            </v-tab>
            <v-tab href="#modificadas">
              <v-icon left>mdi-calendar-sync</v-icon>
              Fechas modificadas / adelantados
            </v-tab>
          </v-tabs>
        </v-card>

        <v-row v-if="tabCalculo === 'mes'" class="mb-4" dense>
          <v-col cols="12" sm="6" md="3" lg="2" v-for="card in cardsResumen" :key="card.key">
            <v-card :color="card.color" dark elevation="2" class="summary-card">
              <v-card-text class="text-center">
                <v-icon color="white" class="mb-2">{{ card.icon }}</v-icon>
                <div class="text-h5 font-weight-bold">{{ formatMonto(card.value) }}</div>
                <div class="text-caption text-uppercase">{{ card.title }}</div>
                <template v-if="card.cobranza !== undefined || card.marketing !== undefined">
                  <v-divider dark class="my-2"></v-divider>
                  <v-row no-gutters justify="space-around" align="center">
                    <v-col cols="6" class="px-1">
                      <div class="caption font-weight-bold">{{ formatMonto(card.cobranza || 0) }}</div>
                      <v-chip color="red lighten-1" x-small text-color="white" class="mt-1">
                        <v-icon left x-small>mdi-cash</v-icon>Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6" class="px-1">
                      <div class="caption font-weight-bold">{{ formatMonto(card.marketing || 0) }}</div>
                      <v-chip color="green lighten-1" x-small text-color="white" class="mt-1">
                        <v-icon left x-small>mdi-account-group</v-icon>Marketing
                      </v-chip>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="tabCalculo === 'mes' && itemsCambiados.length" class="mb-4" dense align="center">
          <v-col cols="12" class="py-1">
            <div class="caption grey--text font-italic">
              <v-icon small color="grey">mdi-information-outline</v-icon>
              No se incluye en la asignacion del mes (ver tab "Fechas modificadas / adelantados"):
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" v-for="card in cardsCambiados" :key="card.key">
            <v-card :color="card.color" dark elevation="2" class="summary-card">
              <v-card-text class="text-center">
                <v-icon color="white" class="mb-2">{{ card.icon }}</v-icon>
                <div class="text-h5 font-weight-bold">{{ formatMonto(card.value) }}</div>
                <div class="text-caption text-uppercase">{{ card.title }}</div>
                <template v-if="card.cobranza !== undefined || card.marketing !== undefined">
                  <v-divider dark class="my-2"></v-divider>
                  <v-row no-gutters justify="space-around" align="center">
                    <v-col cols="6" class="px-1">
                      <div class="caption font-weight-bold">{{ formatMonto(card.cobranza || 0) }}</div>
                      <v-chip color="red lighten-1" x-small text-color="white" class="mt-1">
                        <v-icon left x-small>mdi-cash</v-icon>Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6" class="px-1">
                      <div class="caption font-weight-bold">{{ formatMonto(card.marketing || 0) }}</div>
                      <v-chip color="green lighten-1" x-small text-color="white" class="mt-1">
                        <v-icon left x-small>mdi-account-group</v-icon>Marketing
                      </v-chip>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="tabCalculo === 'modificadas'" class="mb-4" dense>
          <v-col cols="12" sm="6" md="3" lg="2" v-for="card in cardsFechasModificadas" :key="card.key">
            <v-card :color="card.color" dark elevation="2" class="summary-card">
              <v-card-text class="text-center">
                <v-icon color="white" class="mb-2">{{ card.icon }}</v-icon>
                <div class="text-h5 font-weight-bold">{{ formatMonto(card.value) }}</div>
                <div class="text-caption text-uppercase">{{ card.title }}</div>
                <template v-if="card.cobranza !== undefined || card.marketing !== undefined">
                  <v-divider dark class="my-2"></v-divider>
                  <v-row no-gutters justify="space-around" align="center">
                    <v-col cols="6" class="px-1">
                      <div class="caption font-weight-bold">{{ formatMonto(card.cobranza || 0) }}</div>
                      <v-chip color="red lighten-1" x-small text-color="white" class="mt-1">
                        <v-icon left x-small>mdi-cash</v-icon>Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6" class="px-1">
                      <div class="caption font-weight-bold">{{ formatMonto(card.marketing || 0) }}</div>
                      <v-chip color="green lighten-1" x-small text-color="white" class="mt-1">
                        <v-icon left x-small>mdi-account-group</v-icon>Marketing
                      </v-chip>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-card class="mb-4" elevation="2">
          <v-card-title class="primary white--text py-3">
            <v-icon color="white" left>mdi-filter-variant</v-icon>
            Filtros
            <v-spacer></v-spacer>
            <v-chip color="white" outlined>{{ datosFiltrados.length }} de {{ asignacionesAgrupadas.length }}</v-chip>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field v-model="busqueda" label="Buscar estudiante, documento, correo o programa" prepend-inner-icon="mdi-magnify" outlined dense clearable hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-select v-model="filtroAsignacion" :items="opcionesAsignacion" label="Asignacion" outlined dense hide-details></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select v-model="filtroEstado" :items="opcionesEstado" label="Estado" outlined dense hide-details></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select v-model="filtroConceptos" :items="opcionesConcepto" item-text="text" item-value="value" label="Conceptos" multiple chips clearable outlined dense hide-details></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select v-model="filtroTipoPlan" :items="opcionesTipoPlan" label="Tipo plan" outlined dense hide-details></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select v-model="filtroFechaCambiada" :items="opcionesSiNo" label="Fecha cambiada" outlined dense hide-details></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select v-model="filtroConPago" :items="opcionesSiNo" label="Con pago" outlined dense hide-details></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select v-model="filtroConDescuento" :items="opcionesSiNo" label="Con descuento" outlined dense hide-details></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select v-model="filtroRevertido" :items="opcionesSiNo" label="Revertido" outlined dense hide-details></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field v-model="saldoMin" label="Saldo min" type="number" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field v-model="saldoMax" label="Saldo max" type="number" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn color="error" outlined block @click="limpiarFiltros">
                  <v-icon left>mdi-filter-remove</v-icon>
                  Limpiar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card v-if="tabCalculo === 'mes'" class="mb-4" elevation="2">
          <v-card-title class="white--text py-3" style="background-color:#1976d2">
            <v-icon color="white" left>mdi-chart-box</v-icon>
            Graficos administrativos
            <v-spacer></v-spacer>
            <v-btn icon dark @click="mostrarGraficos = !mostrarGraficos">
              <v-icon>{{ mostrarGraficos ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <div v-show="mostrarGraficos">
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="6" lg="3">
                    <div class="text-center subtitle-2 mb-2">Avance de cobranza</div>
                    <div class="chart-wrapper">
                      <canvas ref="chartProgreso"></canvas>
                      <div class="chart-center-label">
                        <div class="text-h4 font-weight-bold primary--text">{{ porcentajeCobranza }}%</div>
                        <div class="caption grey--text">cobrado</div>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" lg="3">
                    <div class="text-center subtitle-2 mb-2">Composicion de la asignacion</div>
                    <div class="chart-wrapper">
                      <canvas ref="chartComposicion"></canvas>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" lg="3">
                    <div class="text-center subtitle-2 mb-2">Estado de asignaciones</div>
                    <div class="chart-wrapper">
                      <canvas ref="chartEstado"></canvas>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" lg="3">
                    <div class="text-center subtitle-2 mb-2">Top 10 programas por saldo</div>
                    <div class="chart-wrapper">
                      <canvas ref="chartTopProgramas"></canvas>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>

        <v-card v-if="tabCalculo === 'mes'" class="mb-4" elevation="2">
          <v-card-title class="white--text py-3" style="background-color:#1976d2">
            <v-icon color="white" left>mdi-school</v-icon>
            Resumen por programa
            <v-spacer></v-spacer>
            <v-chip color="white" outlined>{{ resumenProgramasMes.length }} programas</v-chip>
          </v-card-title>
          <v-data-table :headers="headersProgramas" :items="resumenProgramasMes" :items-per-page="10" dense>
            <template v-slot:item.asignacion="{ item }">{{ formatMonto(item.asignacion) }}</template>
            <template v-slot:item.asignacion_inicial="{ item }">{{ formatMonto(item.asignacion_inicial) }}</template>
            <template v-slot:item.revertidos="{ item }">{{ formatMonto(item.revertidos) }}</template>
            <template v-slot:item.nuevos="{ item }">{{ formatMonto(item.nuevos) }}</template>
            <template v-slot:item.descuento="{ item }">{{ formatMonto(item.descuento) }}</template>
            <template v-slot:item.cambiados="{ item }">{{ formatMonto(item.cambiados) }}</template>
            <template v-slot:item.adelantados="{ item }">{{ formatMonto(item.adelantados) }}</template>
            <template v-slot:item.pagados="{ item }">{{ formatMonto(item.pagados) }}</template>
            <template v-slot:item.saldo="{ item }">{{ formatMonto(item.saldo) }}</template>
          </v-data-table>
        </v-card>

        <v-card v-if="tabCalculo === 'mes'" elevation="2">
          <v-card-title class="primary white--text py-3">
            <v-icon color="white" left>mdi-table</v-icon>
            Detalle de asignaciones V7
          </v-card-title>
          <v-data-table
            :headers="headersDetalle"
            :items="datosAsignacionMes"
            :loading="loading"
            :items-per-page="25"
            class="elevation-0"
            dense
          >
            <template v-slot:item.estudiante="{ item }">
              <div>
                <div class="font-weight-bold">{{ item.nombres }} {{ item.apellidos }}</div>
                <div class="caption grey--text">{{ item.num_doc }}</div>
                <div class="caption">{{ item.correo }}</div>
              </div>
            </template>
            <template v-slot:item.programa="{ item }">
              <div>
                <div class="font-weight-medium">{{ item.codigo || 'S/C' }}</div>
                <div class="caption">{{ item.nombre_compuesto }}</div>
              </div>
            </template>
            <template v-slot:item.estado_asignacion="{ item }">
              <v-chip :color="getColorEstado(item.estado_asignacion)" small dark>{{ item.estado_asignacion }}</v-chip>
            </template>
            <template v-slot:item.asignacion="{ item }">
              <v-chip :color="item.asignacion === 'Nuevos Inscritos' ? 'green' : 'deep-orange'" small dark>{{ item.asignacion }}</v-chip>
            </template>
            <template v-slot:item.plan="{ item }">
              <div>
                <v-chip small color="blue" dark>{{ item.tipo_plan || 'S/P' }}</v-chip>
                <div class="caption">{{ item.concepto }} #{{ item.nro_cuota }}</div>
              </div>
            </template>
            <template v-slot:item.fecha_cambiada="{ item }">
              <v-chip :color="esFechaCambiada(item) ? 'primary' : 'grey'" small dark>
                <v-icon small>{{ esFechaCambiada(item) ? 'mdi-check' : 'mdi-close' }}</v-icon>
              </v-chip>
            </template>
            <template v-slot:item.tipo_movimiento="{ item }">
              <v-chip :color="colorTipoMovimiento(item)" small dark>
                {{ tipoMovimientoGrupo(item) }}
              </v-chip>
            </template>
            <template v-slot:item.fechas_pago="{ item }">
              <div class="caption">
                <div><v-icon x-small>mdi-calendar-clock</v-icon> Límite: {{ formatFecha(item.fecha_limite_pago) }}</div>
                <div><v-icon x-small>mdi-calendar-start</v-icon> Original: {{ formatFecha(item.fecha_original) }}</div>
                <div v-if="item.fecha_actual"><v-icon x-small>mdi-calendar-sync</v-icon> Actual: {{ formatFecha(item.fecha_actual) }}</div>
                <div v-for="(fechaPago, index) in fechasPagoItem(item)" :key="`pago-${index}`" class="success--text">
                  <v-icon x-small color="success">mdi-cash-check</v-icon> Pago: {{ formatFecha(fechaPago) }}
                </div>
              </div>
            </template>
            <template v-slot:item.asignacion_inicial="{ item }">{{ formatMonto(valorAsignacionInicial(item)) }}</template>
            <template v-slot:item.revertido="{ item }">{{ formatMonto(valorRevertido(item)) }}</template>
            <template v-slot:item.descuento="{ item }">{{ formatMonto(valorDescuento(item)) }}</template>
            <template v-slot:item.cambiado="{ item }">{{ formatMonto(valorCambiado(item)) }}</template>
            <template v-slot:item.adelantado="{ item }">{{ formatMonto(valorAdelantado(item)) }}</template>
            <template v-slot:item.pagado="{ item }">{{ formatMonto(valorPagado(item)) }}</template>
            <template v-slot:item.saldo="{ item }">
              <strong :class="calcularSaldoItem(item) > 0 ? 'error--text' : 'success--text'">{{ formatMonto(calcularSaldoItem(item)) }}</strong>
            </template>
          </v-data-table>
        </v-card>

        <v-card v-else elevation="2">
          <v-card-title class="primary white--text py-3">
            <v-icon color="white" left>mdi-calendar-sync</v-icon>
            Fechas modificadas y pagos adelantados
            <v-spacer></v-spacer>
            <v-chip color="white" outlined>{{ datosFechasModificadas.length }} registros</v-chip>
          </v-card-title>
          <v-data-table
            :headers="headersFechasModificadas"
            :items="datosFechasModificadas"
            :loading="loading"
            :items-per-page="25"
            class="elevation-0"
            dense
          >
            <template v-slot:item.estudiante="{ item }">
              <div>
                <div class="font-weight-bold">{{ item.nombres }} {{ item.apellidos }}</div>
                <div class="caption grey--text">{{ item.num_doc }}</div>
                <div class="caption">{{ item.correo }}</div>
              </div>
            </template>
            <template v-slot:item.programa="{ item }">
              <div>
                <div class="font-weight-medium">{{ item.codigo || 'S/C' }}</div>
                <div class="caption">{{ item.nombre_compuesto }}</div>
              </div>
            </template>
            <template v-slot:item.plan="{ item }">
              <div>
                <v-chip small color="blue" dark>{{ item.tipo_plan || 'S/P' }}</v-chip>
                <div class="caption">{{ item.concepto }} #{{ item.nro_cuota }}</div>
              </div>
            </template>
            <template v-slot:item.tipo_adelantado="{ item }">
              <v-chip :color="colorTipoAdelantado(item)" small dark>{{ etiquetaTipoAdelantado(item) }}</v-chip>
            </template>
            <template v-slot:item.cambiado="{ item }">{{ formatMonto(valorCambiado(item)) }}</template>
            <template v-slot:item.adelantado="{ item }">{{ formatMonto(valorAdelantado(item)) }}</template>
            <template v-slot:item.pagado_original="{ item }">{{ formatMonto(valorPagadoBruto(item)) }}</template>
            <template v-slot:item.fecha_actual="{ item }">{{ formatFecha(item.fecha_actual) }}</template>
          </v-data-table>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import xaxios from '@/xaxios';
import Chart from 'chart.js';
import asignacionFormatos from '@/mixins/asignacionFormatos';

export default {
  name: 'AsignacionesSedeV7',
  mixins: [asignacionFormatos],
  data() {
    const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      loading: false,
      msg: '',
      msgType: 'info',
      menuFechaInicio: false,
      menuFechaConsulta: false,
      fechaInicioMes: new Date(firstDay - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      fechaConsulta: today.toISOString().substr(0, 10),
      sedeId: '',
      sedeNombre: '',
      apiBaseV7: process.env.VUE_APP_API_REST || 'http://localhost:8092',
      tabCalculo: 'mes',
      mostrarGraficos: true,
      asignaciones: [],
      busqueda: '',
      filtroAsignacion: 'todos',
      filtroEstado: 'todos',
      filtroTipoPlan: 'todos',
      filtroConceptos: [],
      filtroFechaCambiada: 'todos',
      filtroConPago: 'todos',
      filtroConDescuento: 'todos',
      filtroRevertido: 'todos',
      saldoMin: '',
      saldoMax: '',
      headersProgramas: [
        { text: 'Codigo', value: 'codigo' },
        { text: 'Programa', value: 'nombre_compuesto' },
        { text: 'Estudiantes', value: 'estudiantes', align: 'center' },
        { text: 'Registros', value: 'registros', align: 'center' },
        { text: 'Asignacion', value: 'asignacion', align: 'end' },
        { text: 'Asignacion inicial', value: 'asignacion_inicial', align: 'end' },
        { text: 'Revertidos', value: 'revertidos', align: 'end' },
        { text: 'Nuevos', value: 'nuevos', align: 'end' },
        { text: 'Adelantados', value: 'adelantados', align: 'end' },
        { text: 'Descuento', value: 'descuento', align: 'end' },
        { text: 'Cambiados', value: 'cambiados', align: 'end' },
        { text: 'Pagados', value: 'pagados', align: 'end' },
        { text: 'Saldo', value: 'saldo', align: 'end' },
      ],
      headersDetalle: [
        { text: 'Estado', value: 'estado_asignacion', width: '120px' },
        { text: 'Estudiante', value: 'estudiante', sortable: false },
        { text: 'Programa', value: 'programa', sortable: false },
        { text: 'Asignacion', value: 'asignacion' },
        { text: 'Plan', value: 'plan', sortable: false },
        { text: 'Fecha cambiada', value: 'fecha_cambiada', align: 'center' },
        { text: 'Tipo', value: 'tipo_movimiento', align: 'center' },
        { text: 'Fechas de pago', value: 'fechas_pago', sortable: false },
        { text: 'Inicial', value: 'asignacion_inicial', align: 'end' },
        { text: 'Revertido', value: 'revertido', align: 'end' },
        { text: 'Descuento', value: 'descuento', align: 'end' },
        { text: 'Cambiado', value: 'cambiado', align: 'end' },
        { text: 'Pagado', value: 'pagado', align: 'end' },
        { text: 'Saldo', value: 'saldo', align: 'end' },
        { text: 'Asesor', value: 'asesor' },
      ],
      headersFechasModificadas: [
        { text: 'Tipo', value: 'tipo_adelantado', align: 'center', width: '160px' },
        { text: 'Estudiante', value: 'estudiante', sortable: false },
        { text: 'Programa', value: 'programa', sortable: false },
        { text: 'Plan', value: 'plan', sortable: false },
        { text: 'Fecha actual', value: 'fecha_actual', align: 'center' },
        { text: 'Cambiado', value: 'cambiado', align: 'end' },
        { text: 'Pago adelantado', value: 'adelantado', align: 'end' },
        { text: 'Pago original', value: 'pagado_original', align: 'end' },
        { text: 'Asesor', value: 'asesor' },
      ],
    };
  },
  computed: {
    sedeSeleccionadaTexto() {
      const nombre = this.sedeNombre || 'Sin nombre';
      return `${nombre} (${this.sedeId || 'sin id'})`;
    },
    opcionesSiNo() {
      return [
        { text: 'Todos', value: 'todos' },
        { text: 'Si', value: 'si' },
        { text: 'No', value: 'no' },
      ];
    },
    opcionesEstado() {
      return this.opcionesUnicas('estado_asignacion', 'Todos');
    },
    opcionesAsignacion() {
      return this.opcionesUnicas('asignacion', 'Todas');
    },
    opcionesTipoPlan() {
      return this.opcionesUnicas('tipo_plan', 'Todos');
    },
    opcionesConcepto() {
      const conceptos = new Map();
      this.asignaciones.forEach(item => {
        if (item.concepto_pago_id != null && item.concepto) {
          conceptos.set(item.concepto_pago_id, item.concepto);
        }
      });
      return Array.from(conceptos, ([value, text]) => ({ value, text })).sort((a, b) => a.text.localeCompare(b.text));
    },
    asignacionesAgrupadas() {
      const grupos = new Map();
      this.asignaciones.forEach(item => {
        const key = item.plan_pagos_id || item.id || `${item.inscripcion_id}-${item.concepto_pago_id}-${item.nro_cuota}`;
        if (!grupos.has(key)) {
          grupos.set(key, {
            ...item,
            tipo_registro: 'agrupado',
            tipos_registro: new Set(),
            movimientos: [],
          });
        }
        const grupo = grupos.get(key);
        grupo.movimientos.push(item);
        grupo.tipos_registro.add(this.tipoRegistro(item));
        if (this.tipoRegistro(item) === 'dw') {
          Object.assign(grupo, {
            ...grupo,
            ...item,
            tipo_registro: 'agrupado',
            tipos_registro: grupo.tipos_registro,
            movimientos: grupo.movimientos,
          });
        }
      });

      return Array.from(grupos.values()).map(grupo => ({
        ...grupo,
        tipos_registro: Array.from(grupo.tipos_registro).filter(Boolean).join(', '),
      }));
    },
    datosFiltrados() {
      let datos = this.asignacionesAgrupadas;

      if (this.filtroAsignacion !== 'todos') {
        datos = datos.filter(item => item.asignacion === this.filtroAsignacion);
      }
      if (this.filtroEstado !== 'todos') {
        datos = datos.filter(item => item.estado_asignacion === this.filtroEstado);
      }
      if (this.filtroTipoPlan !== 'todos') {
        datos = datos.filter(item => item.tipo_plan === this.filtroTipoPlan);
      }
      if (this.filtroConceptos.length > 0) {
        datos = datos.filter(item => this.filtroConceptos.includes(item.concepto_pago_id));
      }
      if (this.filtroFechaCambiada !== 'todos') {
        const expected = this.filtroFechaCambiada === 'si';
        datos = datos.filter(item => this.esFechaCambiada(item) === expected);
      }
      if (this.filtroConPago !== 'todos') {
        const expected = this.filtroConPago === 'si';
        datos = datos.filter(item => (this.valorPagadoBruto(item) > 0) === expected);
      }
      if (this.filtroConDescuento !== 'todos') {
        const expected = this.filtroConDescuento === 'si';
        datos = datos.filter(item => (this.valorDescuento(item) > 0) === expected);
      }
      if (this.filtroRevertido !== 'todos') {
        const expected = this.filtroRevertido === 'si';
        datos = datos.filter(item => (this.valorRevertido(item) > 0) === expected);
      }
      if (this.busqueda) {
        const q = this.busqueda.toLowerCase();
        datos = datos.filter(item => [
          item.nombres,
          item.apellidos,
          item.num_doc,
          item.correo,
          item.telefono,
          item.codigo,
          item.nombre_compuesto,
        ].some(value => String(value || '').toLowerCase().includes(q)));
      }

      const saldoMin = Number(this.saldoMin);
      if (!Number.isNaN(saldoMin) && this.saldoMin !== '') {
        datos = datos.filter(item => this.calcularSaldoItem(item) >= saldoMin);
      }
      const saldoMax = Number(this.saldoMax);
      if (!Number.isNaN(saldoMax) && this.saldoMax !== '') {
        datos = datos.filter(item => this.calcularSaldoItem(item) <= saldoMax);
      }

      return datos;
    },
    datosAsignacionMes() {
      return this.datosFiltrados.filter(item => !this.esFechaCambiada(item));
    },
    itemsCambiados() {
      return this.datosFiltrados.filter(item => this.esFechaCambiada(item));
    },
    datosFechasModificadas() {
      return this.datosFiltrados.filter(item => this.esAdelantado(item));
    },
    resumen() {
      return this.calcularResumen(this.datosAsignacionMes);
    },
    resumenCambiados() {
      return this.calcularResumen(this.itemsCambiados);
    },
    resumenFechasModificadas() {
      return this.calcularResumen(this.datosFechasModificadas);
    },
    cardsResumen() {
      const r = this.resumen;
      const mk = (key, title, color, icon) => ({
        key, title, color, icon,
        value: r[key],
        cobranza: r[`${key}_cobranza`],
        marketing: r[`${key}_marketing`],
      });
      return [
        mk('asignacion', 'Asignacion', 'cyan darken-3', 'mdi-calculator-variant'),
        mk('asignacion_inicial', 'Asignacion inicial', 'teal darken-2', 'mdi-clipboard-text'),
        mk('revertidos', 'Revertidos', 'deep-orange darken-2', 'mdi-undo'),
        mk('nuevos', 'Nuevos', 'green darken-2', 'mdi-account-plus'),
        mk('adelantados', 'Adelantados', 'indigo darken-2', 'mdi-fast-forward'),
        mk('descuento', 'Descuento', 'orange darken-2', 'mdi-percent'),
        mk('pagados', 'Pagados', 'blue darken-2', 'mdi-cash-check'),
        mk('saldo', 'Saldo', 'red darken-2', 'mdi-cash-clock'),
      ];
    },
    cardsFechasModificadas() {
      const r = this.resumenFechasModificadas;
      const mk = (key, title, color, icon) => ({
        key, title, color, icon,
        value: r[key],
        cobranza: r[`${key}_cobranza`],
        marketing: r[`${key}_marketing`],
      });
      return [
        mk('cambiados', 'Cambiados', 'purple darken-2', 'mdi-calendar-sync'),
        mk('adelantados', 'Adelantados', 'indigo darken-2', 'mdi-fast-forward'),
        mk('pagado_original', 'Pagado original', 'blue darken-2', 'mdi-cash-check'),
      ];
    },
    cardsCambiados() {
      const r = this.resumenCambiados;
      return [
        {
          key: 'cambiados',
          title: 'Cambiados (fechas modificadas)',
          color: 'purple darken-2',
          icon: 'mdi-calendar-sync',
          value: r.cambiados,
          cobranza: r.cambiados_cobranza,
          marketing: r.cambiados_marketing,
        },
      ];
    },
    resumenProgramasMes() {
      return this.agruparProgramas(this.datosAsignacionMes);
    },
    resumenProgramas() {
      return this.agruparProgramas(this.datosFiltrados);
    },
    porcentajeCobranza() {
      const asign = this.resumen.asignacion;
      if (!asign) return 0;
      const pct = (this.resumen.pagados / asign) * 100;
      return Math.max(0, Math.min(100, Math.round(pct)));
    },
    estadisticasPorEstado() {
      const conteos = { vigente: 0, retrasado: 0, 'por recuperar': 0, otro: 0 };
      this.datosAsignacionMes.forEach(item => {
        const estado = item.estado_asignacion;
        if (conteos[estado] !== undefined) conteos[estado] += 1;
        else conteos.otro += 1;
      });
      return conteos;
    },
    topProgramasPorSaldo() {
      return [...this.resumenProgramasMes]
        .filter(p => p.saldo > 0)
        .sort((a, b) => b.saldo - a.saldo)
        .slice(0, 10);
    },
  },
  watch: {
    '$store.state.CARGO.sede': function() {
      this.setSedePorDefecto();
      this.cargarAsignaciones();
    },
    datosAsignacionMes() {
      if (this.tabCalculo === 'mes' && this.mostrarGraficos) this.renderGraficos();
    },
    tabCalculo(val) {
      if (val === 'mes' && this.mostrarGraficos) this.renderGraficos();
    },
    mostrarGraficos(val) {
      if (val) this.renderGraficos();
      else this.destroyAllCharts();
    },
  },
  created() {
    this.chartInstances = { progreso: null, composicion: null, estado: null, topProgramas: null };
  },
  mounted() {
    this.setSedePorDefecto();
    this.cargarAsignaciones();
  },
  methods: {
    calcularResumen(datos) {
      const claves = ['asignacion', 'asignacion_inicial', 'revertidos', 'nuevos', 'descuento', 'cambiados', 'adelantados', 'pagados', 'pagado_original', 'saldo'];
      const acc = {};
      claves.forEach(k => {
        acc[k] = 0;
        acc[`${k}_cobranza`] = 0;
        acc[`${k}_marketing`] = 0;
      });

      datos.forEach(item => {
        const valores = {
          asignacion: this.calcularAsignacionItem(item),
          asignacion_inicial: this.valorAsignacionInicial(item),
          revertidos: this.valorRevertido(item),
          nuevos: this.valorNuevo(item),
          descuento: this.valorDescuento(item),
          cambiados: this.valorCambiado(item),
          adelantados: this.valorAdelantado(item),
          pagados: this.valorPagado(item),
          pagado_original: this.valorPagadoBruto(item),
          saldo: this.calcularSaldoItem(item),
        };
        const esCobranza = item.asignacion === 'Cartera Activa';
        const esMarketing = item.asignacion === 'Nuevos Inscritos';
        claves.forEach(k => {
          acc[k] += valores[k];
          if (esCobranza) acc[`${k}_cobranza`] += valores[k];
          else if (esMarketing) acc[`${k}_marketing`] += valores[k];
        });
      });

      return acc;
    },
    agruparProgramas(datos) {
      const grupos = {};
      datos.forEach(item => {
        const key = item.idprograma || item.nombre_compuesto || 'sin-programa';
        if (!grupos[key]) {
          grupos[key] = {
            idprograma: item.idprograma,
            codigo: item.codigo || 'S/C',
            nombre_compuesto: item.nombre_compuesto || 'Sin programa',
            estudiantesSet: new Set(),
            registros: 0,
            asignacion: 0,
            asignacion_inicial: 0,
            revertidos: 0,
            nuevos: 0,
            descuento: 0,
            cambiados: 0,
            adelantados: 0,
            pagados: 0,
            saldo: 0,
          };
        }
        const grupo = grupos[key];
        grupo.registros += 1;
        if (item.idestudiante != null) grupo.estudiantesSet.add(item.idestudiante);
        grupo.asignacion += this.calcularAsignacionItem(item);
        grupo.asignacion_inicial += this.valorAsignacionInicial(item);
        grupo.revertidos += this.valorRevertido(item);
        grupo.nuevos += this.valorNuevo(item);
        grupo.descuento += this.valorDescuento(item);
        grupo.cambiados += this.valorCambiado(item);
        grupo.adelantados += this.valorAdelantado(item);
        grupo.pagados += this.valorPagado(item);
        grupo.saldo += this.calcularSaldoItem(item);
      });

      return Object.values(grupos).map(grupo => ({
        ...grupo,
        estudiantes: grupo.estudiantesSet.size,
      })).sort((a, b) => b.saldo - a.saldo);
    },
    setSedePorDefecto() {
      const querySede = this.$route.query.sede || this.$route.query.idsede;
      const queryNombre = this.$route.query.name || this.$route.query.sede_nombre;
      const storeSede = this.$store.state.CARGO && this.$store.state.CARGO.sede ? this.$store.state.CARGO.sede : null;
      if (querySede) {
        this.sedeId = querySede;
        this.sedeNombre = queryNombre || this.sedeNombre || 'Sede por URL';
        return;
      }
      this.sedeId = storeSede && storeSede.id ? storeSede.id : 1;
      this.sedeNombre = storeSede && storeSede.nombre ? storeSede.nombre : 'Sede actual';
    },
    async cargarAsignaciones() {
      if (!this.validarFechas()) return;
      this.loading = true;
      this.msg = '';

      try {
        const url = `${this.apiBaseV7}/api/v7/esam/asignacion/programas`;
        const response = await xaxios.get(url, {
          params: {
            fecha_inicio_mes: this.fechaInicioMes,
            fecha_consulta: this.fechaConsulta,
            sede: this.sedeId,
          },
        });
        const data = response.data && response.data.data ? response.data.data : [];
        this.asignaciones = data.map(this.normalizarAsignacion);
        this.msgType = this.asignaciones.length ? 'success' : 'info';
        this.msg = this.asignaciones.length ? 'Asignaciones v7 cargadas correctamente.' : 'No se encontraron asignaciones para los filtros seleccionados.';
      } catch (error) {
        this.asignaciones = [];
        this.msgType = 'error';
        this.msg = error?.response?.data?.message || error?.response?.data?.error || error?.message || 'Error al consultar asignaciones v7.';
        window.console.error('Error al consultar asignaciones v7:', error);
      } finally {
        this.loading = false;
      }
    },
    validarFechas() {
      if (!this.fechaInicioMes || !this.fechaConsulta) {
        this.msgType = 'warning';
        this.msg = 'Debe seleccionar fecha inicio mes y fecha consulta.';
        return false;
      }
      if (this.fechaInicioMes > this.fechaConsulta) {
        this.msgType = 'warning';
        this.msg = 'La fecha inicio mes no puede ser mayor a la fecha consulta.';
        return false;
      }
      return true;
    },
    normalizarAsignacion(item) {
      return {
        ...item,
        monto: this.toNumber(item.monto),
        descuento_inicio: this.toNumber(item.descuento_inicio),
        pagado_inicio: this.toNumber(item.pagado_inicio),
        saldo_inicio: this.toNumber(item.saldo_inicio),
        descuento_fecha: this.toNumber(item.descuento_fecha),
        pagado_fecha: this.toNumber(item.pagado_fecha),
        saldo_fecha: this.toNumber(item.saldo_fecha),
        total_descuento_fecha_consulta: this.toNumber(item.total_descuento_fecha_consulta),
        total_pagado_fecha_consulta: this.toNumber(item.total_pagado_fecha_consulta),
        monto_descuento_revertido: this.toNumber(item.monto_descuento_revertido),
        plan_modificado: Number(item.plan_modificado) || 0,
        es_reincorporado: Number(item.es_reincorporado) || 0,
        concepto_pago_id: Number(item.concepto_pago_id),
      };
    },
    opcionesUnicas(campo, textoTodos) {
      const opciones = [{ text: textoTodos, value: 'todos' }];
      const valores = new Set(this.asignaciones.map(item => item[campo]).filter(Boolean));
      Array.from(valores).sort().forEach(value => opciones.push({ text: value, value }));
      return opciones;
    },
    toNumber(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    },
    movimientosItem(item) {
      return Array.isArray(item.movimientos) && item.movimientos.length ? item.movimientos : [item];
    },
    tipoRegistro(item) {
      return String(item.tipo_registro || '').trim().toLowerCase();
    },
    esNuevo(item) {
      return this.movimientosItem(item).some(movimiento => this.tipoRegistro(movimiento) === 'nuevo');
    },
    tipoMovimientoGrupo(item) {
      if (this.esAdelantadoPorNuevo(item)) return 'adelantado';
      if (this.esAdelantadoPorPago(item)) return 'adelantado';
      const tipos = this.movimientosItem(item).map(movimiento => this.tipoRegistro(movimiento));
      if (tipos.includes('dw')) return 'dw';
      if (tipos.includes('nuevo')) return 'nuevo';
      if (tipos.includes('descuento_revertido')) return 'revertido';
      if (tipos.includes('descuento_aprobado')) return 'descuento';
      if (tipos.includes('pagado')) return 'pagado';
      if (tipos.includes('cambio_fecha') || tipos.includes('fecha_cambiada')) return 'cambiado';
      return tipos.find(Boolean) || 'sin tipo';
    },
    colorTipoMovimiento(item) {
      const tipo = this.tipoMovimientoGrupo(item);
      if (tipo === 'dw') return 'blue';
      if (tipo === 'nuevo') return 'green';
      if (tipo === 'adelantado') return 'indigo';
      if (tipo === 'revertido') return 'deep-orange';
      if (tipo === 'descuento') return 'orange';
      if (tipo === 'pagado') return 'teal';
      if (tipo === 'cambiado') return 'purple';
      return 'grey';
    },
    fechasPagoItem(item) {
      return this.movimientosItem(item)
        .filter(movimiento => this.tipoRegistro(movimiento) === 'pagado' || this.toNumber(movimiento.total_pagado_fecha_consulta || movimiento.pagado_fecha) > 0)
        .map(movimiento => movimiento.fecha_pago || movimiento.fecha_pagado || movimiento.fecha_registro || movimiento.fecha_creacion)
        .filter(Boolean)
        .map(fecha => String(fecha).substr(0, 10))
        .filter((fecha, index, fechas) => fechas.indexOf(fecha) === index);
    },
    valorMovimiento(item) {
      return this.toNumber(item.monto || item.saldo_fecha || item.saldo_inicio);
    },
    valorAsignacionInicial(item) {
      return this.movimientosItem(item).reduce((sum, movimiento) => {
        return this.tipoRegistro(movimiento) === 'dw' ? sum + this.toNumber(movimiento.saldo_inicio) : sum;
      }, 0);
    },
    valorRevertido(item) {
      return this.movimientosItem(item).reduce((sum, movimiento) => {
        return this.tipoRegistro(movimiento) === 'descuento_revertido' ? sum + this.toNumber(movimiento.monto_descuento_revertido) : sum;
      }, 0);
    },
    valorNuevo(item) {
      if (this.esAdelantadoPorNuevo(item)) return 0;
      return this.movimientosItem(item).reduce((sum, movimiento) => {
        return this.tipoRegistro(movimiento) === 'nuevo' ? sum + this.valorMovimiento(movimiento) : sum;
      }, 0);
    },
    valorDescuento(item) {
      return this.movimientosItem(item).reduce((sum, movimiento) => {
        return this.tipoRegistro(movimiento) === 'descuento_aprobado' ? sum + this.toNumber(movimiento.monto_descuento_revertido) : sum;
      }, 0);
    },
    valorPagadoBruto(item) {
      const movimientos = this.movimientosItem(item);
      const pagosPorTipo = movimientos
        .filter(movimiento => this.tipoRegistro(movimiento) === 'pagado')
        .reduce((sum, movimiento) => sum + this.toNumber(movimiento.total_pagado_fecha_consulta), 0);
      if (pagosPorTipo > 0) {
        return pagosPorTipo;
      }
      return Math.max(...movimientos.map(movimiento => this.toNumber(movimiento.total_pagado_fecha_consulta || movimiento.pagado_fecha)), 0);
    },
    valorPagado(item) {
      return Math.max(this.valorPagadoBruto(item) - this.valorAdelantado(item), 0);
    },
    valorAsignacionAntesCambio(item) {
      return this.valorAsignacionInicial(item) + this.valorRevertido(item) + this.valorNuevo(item) - this.valorDescuento(item);
    },
    valorCambiado(item) {
      if (!this.esFechaCambiada(item)) return 0;
      return Math.max(this.valorAsignacionAntesCambio(item), 0);
    },
    valorAdelantado(item) {
      if (this.esAdelantadoPorNuevo(item)) {
        return this.movimientosItem(item).reduce((sum, movimiento) => {
          return this.tipoRegistro(movimiento) === 'nuevo' ? sum + this.valorMovimiento(movimiento) : sum;
        }, 0);
      }
      if (this.esAdelantadoPorPago(item)) {
        return this.valorPagadoBruto(item);
      }
      if (!this.esFechaCambiada(item)) return 0;
      return this.valorPagadoBruto(item);
    },
    calcularAsignacionItem(item) {
      return this.valorAsignacionAntesCambio(item) - this.valorCambiado(item);
    },
    calcularSaldoItem(item) {
      return this.calcularAsignacionItem(item) - this.valorPagado(item);
    },
    esFechaCambiada(item) {
      return this.movimientosItem(item).some(movimiento => {
        return Number(movimiento.plan_modificado) === 1 || ['cambio_fecha', 'fecha_cambiada'].includes(this.tipoRegistro(movimiento));
      });
    },
    esAdelantadoPorNuevo(item) {
      const movimientos = this.movimientosItem(item);
      if (!movimientos.length) return false;
      const todosNuevos = movimientos.every(movimiento => this.tipoRegistro(movimiento) === 'nuevo');
      if (!todosNuevos) return false;
      if (!item.fecha_limite_pago || !this.fechaConsulta) return false;
      const mesLimite = String(item.fecha_limite_pago).slice(0, 7);
      const mesConsulta = String(this.fechaConsulta).slice(0, 7);
      return mesLimite > mesConsulta;
    },
    esAdelantadoPorPago(item) {
      const movimientos = this.movimientosItem(item);
      if (!movimientos.length) return false;
      return movimientos.every(movimiento => this.tipoRegistro(movimiento) === 'pagado');
    },
    esAdelantado(item) {
      return this.esAdelantadoPorNuevo(item) || this.esAdelantadoPorPago(item) || this.esFechaCambiada(item);
    },
    tipoAdelantado(item) {
      if (this.esFechaCambiada(item)) return 'cambiado';
      if (this.esAdelantadoPorPago(item)) return 'adelantado_pago';
      if (this.esAdelantadoPorNuevo(item)) return 'adelantado_nuevo';
      return null;
    },
    etiquetaTipoAdelantado(item) {
      const tipo = this.tipoAdelantado(item);
      if (tipo === 'cambiado') return 'Cambio de fecha';
      if (tipo === 'adelantado_pago') return 'Adelantado (pago)';
      if (tipo === 'adelantado_nuevo') return 'Adelantado (nuevo)';
      return 'S/T';
    },
    colorTipoAdelantado(item) {
      const tipo = this.tipoAdelantado(item);
      if (tipo === 'cambiado') return 'purple';
      if (tipo === 'adelantado_pago') return 'indigo';
      if (tipo === 'adelantado_nuevo') return 'indigo lighten-1';
      return 'grey';
    },
    getColorEstado(estado) {
      if (estado === 'vigente') return 'green';
      if (estado === 'retrasado') return 'red';
      if (estado === 'por recuperar') return 'orange';
      return 'grey';
    },
    limpiarFiltros() {
      this.busqueda = '';
      this.filtroAsignacion = 'todos';
      this.filtroEstado = 'todos';
      this.filtroTipoPlan = 'todos';
      this.filtroConceptos = [];
      this.filtroFechaCambiada = 'todos';
      this.filtroConPago = 'todos';
      this.filtroConDescuento = 'todos';
      this.filtroRevertido = 'todos';
      this.saldoMin = '';
      this.saldoMax = '';
    },
    renderGraficos() {
      this.$nextTick(() => {
        this.renderChartProgreso();
        this.renderChartComposicion();
        this.renderChartEstado();
        this.renderChartTopProgramas();
      });
    },
    destroyChart(key) {
      if (this.chartInstances[key]) {
        this.chartInstances[key].destroy();
        this.chartInstances[key] = null;
      }
    },
    destroyAllCharts() {
      Object.keys(this.chartInstances).forEach(k => this.destroyChart(k));
    },
    formatTooltipMonto(value) {
      return new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    },
    renderChartProgreso() {
      const ref = this.$refs.chartProgreso;
      if (!ref) return;
      this.destroyChart('progreso');
      const pagado = this.resumen.pagados;
      const saldo = Math.max(this.resumen.asignacion - this.resumen.pagados, 0);
      const self = this;
      this.chartInstances.progreso = new Chart(ref.getContext('2d'), {
        type: 'doughnut',
        data: {
          labels: ['Pagado', 'Saldo'],
          datasets: [{ data: [pagado, saldo], backgroundColor: ['#43a047', '#e53935'], borderWidth: 0 }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 72,
          legend: { display: false },
          tooltips: {
            callbacks: {
              label(item, data) {
                const label = data.labels[item.index];
                const value = data.datasets[0].data[item.index];
                return `${label}: ${self.formatTooltipMonto(value)}`;
              },
            },
          },
        },
      });
    },
    renderChartComposicion() {
      const ref = this.$refs.chartComposicion;
      if (!ref) return;
      this.destroyChart('composicion');
      const r = this.resumen;
      const self = this;
      this.chartInstances.composicion = new Chart(ref.getContext('2d'), {
        type: 'doughnut',
        data: {
          labels: ['Inicial', 'Revertidos', 'Nuevos', 'Adelantados', 'Descuento'],
          datasets: [{
            data: [r.asignacion_inicial, r.revertidos, r.nuevos, r.adelantados, r.descuento],
            backgroundColor: ['#00838f', '#e64a19', '#388e3c', '#3949ab', '#f57c00'],
            borderWidth: 0,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom', labels: { boxWidth: 12, fontSize: 10 } },
          tooltips: {
            callbacks: {
              label(item, data) {
                const label = data.labels[item.index];
                const value = data.datasets[0].data[item.index];
                return `${label}: ${self.formatTooltipMonto(value)}`;
              },
            },
          },
        },
      });
    },
    renderChartEstado() {
      const ref = this.$refs.chartEstado;
      if (!ref) return;
      this.destroyChart('estado');
      const e = this.estadisticasPorEstado;
      this.chartInstances.estado = new Chart(ref.getContext('2d'), {
        type: 'doughnut',
        data: {
          labels: ['Vigente', 'Retrasado', 'Por recuperar', 'Otro'],
          datasets: [{
            data: [e.vigente, e.retrasado, e['por recuperar'], e.otro],
            backgroundColor: ['#43a047', '#e53935', '#fb8c00', '#9e9e9e'],
            borderWidth: 0,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom', labels: { boxWidth: 12, fontSize: 10 } },
        },
      });
    },
    renderChartTopProgramas() {
      const ref = this.$refs.chartTopProgramas;
      if (!ref) return;
      this.destroyChart('topProgramas');
      const top = this.topProgramasPorSaldo;
      const self = this;
      this.chartInstances.topProgramas = new Chart(ref.getContext('2d'), {
        type: 'horizontalBar',
        data: {
          labels: top.map(p => p.codigo || 'S/C'),
          datasets: [{
            label: 'Saldo',
            data: top.map(p => p.saldo),
            backgroundColor: '#1976d2',
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          scales: { xAxes: [{ ticks: { beginAtZero: true } }] },
          tooltips: {
            callbacks: {
              label(item) {
                return `Saldo: ${self.formatTooltipMonto(item.xLabel)}`;
              },
            },
          },
        },
      });
    },
  },
  beforeDestroy() {
    this.destroyAllCharts();
  },
};
</script>

<style scoped>
.summary-card {
  min-height: 132px;
}
.chart-wrapper {
  position: relative;
  height: 240px;
}
.chart-center-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
}
</style>
